import { configureStore } from "@reduxjs/toolkit";
import { rolligStartApi, rolligStartExtendedApi } from "@src/services/rollingStartApi";
import rootReducer from "./reducers";

function configureAppStore() {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({
        serializableCheck: false,
        // TBT-FIX: moins de travail synchrone sur chaque action (dev surtout).
        immutableCheck: false,
      }),
      rolligStartApi.middleware,
      rolligStartExtendedApi.middleware,
    ],
  });

  return store;
}
const store = configureAppStore();
export type RootState = ReturnType<typeof store.getState>;

export default store;
